import { useQueryClient } from "@tanstack/react-query";
import { useContext, useState } from "react";
import useGetOrg from "src/hooks/useGetOrganization";
import useLocales from "src/hooks/useLocales";
import { useDeleteRedirectApp } from "src/services/organizations/commands/redirects";
import SnackbarUtils from "src/utils/SnackbarUtils";

import Context from "../../context";
import DialogContext from "../../context";

export default function useDeleteRedirect() {
	const [isLoading, setIsLoading] = useState(false);
	const { state } = useContext(Context);
	const { actions } = useContext(DialogContext);

	const { mutate } = useDeleteRedirectApp();

	const org = useGetOrg();
	const queryClient = useQueryClient();
	const { translate } = useLocales();

	const appId = queryClient.getQueryData<string>(["apps", "selected"]) ?? "";

	const onDeleteRedirect = () => {
		setIsLoading(true);
		mutate(
			{ orgId: org.id, appId, id: state.uriActionId },
			{
				onSuccess: () => {
					setIsLoading(false);
					queryClient.refetchQueries({ queryKey: ["apps", "redirects", appId] });
					SnackbarUtils.success(translate("api_client.delete_redirect_success"));
					actions.hideRemoveUriDialog();
				},
				onError: () => {
					setIsLoading(false);
					SnackbarUtils.error(translate("api_client.delete_redirect_error"));
				}
			}
		);
	};

	return { onDeleteRedirect, isLoading };
}
